import React from 'react';
import { motion } from 'framer-motion';
import './Marquee.css';

const Marquee = () => {
  const values = [
    'Safe Housing',
    'Community Support',
    'Personal Growth',
    'New Opportunities',
    'Structured Living',
    'Resource Access',
    'Fresh Start',
    'Accountability'
  ];

  return (
    <div className="marquee-section">
      <div className="marquee-track">
        <motion.div
          className="marquee-content"
          animate={{ x: [0, -1920] }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear",
            },
          }}
        >
          {[...values, ...values, ...values].map((value, index) => (
            <span key={index} className="marquee-item">
              {value}
              <span className="marquee-dot">•</span>
            </span>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Marquee;
